// react
import { ReactNode } from 'react';

// types
import { Grid, GridProps, SxProps, Typography } from '@mui/material';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { IconCircle, IconCircleProps } from '../IconCircle/IconCircle';

// props
export interface IconListItem {
	IconCircleProps: IconCircleProps;
	value: ReactNode;
}

export interface IconListProps {
	GridItemProps?: GridProps;
	GridItemIconProps?: GridProps;
	GridItemValueProps?: GridProps;
	list: IconListItem[];
	sxGrid?: SxProps;
}

export const IconList = ({
	GridItemProps,
	GridItemIconProps,
	GridItemValueProps,
	list,
	sxGrid,
}: IconListProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<Grid container spacing={1} sx={sxGrid}>
			{list.map((item, i) => {
				const { IconCircleProps, value } = item;

				let val: ReactNode = t('na');

				if (value !== undefined && value !== null) {
					val = value;
				}

				if (typeof val === 'string') {
					val = <Typography>{val}</Typography>;
				}

				return (
					<Grid item key={`icon-list-item-${i}`} xs="auto" lg={12} {...GridItemProps}>
						<Grid alignItems="center" container spacing={1}>
							<Grid item xs="auto" {...GridItemIconProps}>
								<IconCircle size="xs" {...IconCircleProps} />
							</Grid>
							<Grid flex={1} xs={true} item {...GridItemValueProps}>
								{val}
							</Grid>
						</Grid>
					</Grid>
				);
			})}
		</Grid>
	);
};
